import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    content,
    designVersion,
    designContext,
    listItems,
    status,
    title
  } = _ref;
  var cornerRadius = designContext.get('alert-block/corner-radius').value();
  var borderRadius = isLollipop(designVersion) ? 0 : cornerRadius;
  var textColor = designContext.get('alert-block/text-color').toString();
  var textStyle = designContext.get('alert-block/text-style');
  return {
    rootStyle: {
      backgroundColor: designContext.get('alert-block/background-color', {
        status
      }).toString(),
      borderRadius,
      flexDirection: 'row',
      alignItems: 'flex-start',
      padding: designContext.get('space/200').value()
    },
    contentWrapperStyle: {
      flexShrink: 1,
      width: '100%'
    },
    topRowStyle: {},
    titleWrapperStyle: {
      flexShrink: 1
    },
    iconStyle: {
      paddingRight: designContext.get('space/100').value()
    },
    paragraphWrapperStyle: {
      flexShrink: 1,
      marginTop: designContext.get(title ? 'space/100' : 'space/none').value()
    },
    // link
    paragraphSecondaryStyle: _objectSpread(_objectSpread({
      color: textColor
    }, textStyle.styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: 0,
      marginTop: 0
    }),
    // content
    paragraphSecondaryBlockStyle: _objectSpread(_objectSpread({
      color: textColor
    }, textStyle.styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: 0,
      marginTop: 0
    }),
    // title
    paragraphSecondaryBlockMediumStyle: _objectSpread(_objectSpread({
      color: textColor
    }, designContext.get('alert-block/title-text-style').styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: 0,
      marginTop: 0,
      paddingBottom: 0,
      paddingTop: 0
    }),
    linkStyle: {
      paddingTop: designContext.get(content && content.length > 0 || listItems && listItems.length > 0 ? 'space/150' : 'space/none').value()
    },
    listContainerStyle: {
      paddingTop: designContext.get(content && content.length > 0 ? 'space/100' : 'space/none').value()
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map